import React, { useState } from "react";
import "./Navbar.css";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";
import { useNavigate, useLocation, Link } from "react-router-dom";
// If you're using react-bootstrap Button
import { Button } from "react-bootstrap";

// If you're using lucide-react icons
import { FiArrowUpRight } from "react-icons/fi";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isActive = (path) => (location.pathname === path ? "active" : "");

  return (
    <>
      

      {/* Main Navbar */}
      <nav
        className="navbar navbar-expand-lg bg-white"
        style={{ position: "sticky", top: "0", zIndex: 1001, height: "100px" }}
      >
        <div className="container">
          {/* Logo */}
          <a
            className="navbar-brand"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              handleNavigation("/");
            }}
          >
            <img
              src={require("../../assest/image/NavbarLogo (2).png")}
              alt="Aalan TechSoft Logo"
              style={{ height: "50px" }}
            />
          </a>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleMenuToggle}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}>
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-2">
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/")}`}
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/");
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/about-us")}`}
                  to="/about-us"
                  onClick={() => handleNavigation("/about-us")}
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/courses")}`}
                  to="/courses"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/courses");
                  }}
                >
                  Courses
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/internship")}`}
                  to="/internship"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/internship");
                  }}
                >
                  Internship
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/services")}`}
                  to="/services"
                  onClick={() => handleNavigation("/services")}
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/portfolio")}`}
                  to="/portfolio"
                  onClick={() => handleNavigation("/portfolio")}
                >
                  Portfolio
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${isActive("/blogs")}`}
                  to="/blogs"
                  onClick={() => handleNavigation("/blogs")}
                >
                  Blogs
                </Link>
              </li>

              {/* Contact for mobile */}
              <li className="nav-item d-lg-none mt-3">
                <a
                  href="/contactus"
                  className="btn btn-md text-white fw-bold w-100"
                  style={{ backgroundColor: "#85bf39" }}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/contactus");
                  }}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact button desktop */}
          <div className="d-none d-lg-block">
            <Button
              className="custom-btn shadow-sm"
              onClick={() => handleNavigation("/contactus")}
            >
              <span className="btn-text fw-semibold">Contact us</span>
              <span className="btn-icon ms-2">
                <FiArrowUpRight />
              </span>
            </Button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;